import { useMutation, useQueryClient } from '@tanstack/react-query';
import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { useEffect } from 'react';
import { z } from 'zod';
import { authQueryKey, redeemLoginLink } from '../lib/auth.ts';
import { AuthScreen } from '../features/auth/AuthScreen.tsx';
import { m } from '../paraglide/messages.js';

/** One-time link from the admin CLI: signs in, then asks for a new passkey. */
export const Route = createFileRoute('/login-link')({
  validateSearch: z.object({ token: z.string().catch('') }),
  component: LoginLinkRoute,
});

function LoginLinkRoute() {
  const { token } = Route.useSearch();
  const navigate = useNavigate();
  const queryClient = useQueryClient();
  const { mutate, isError } = useMutation({
    mutationFn: () => redeemLoginLink(token),
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: authQueryKey });
      await navigate({ to: '/recipes', replace: true });
    },
  });

  useEffect(() => mutate(), [mutate]);

  return (
    <AuthScreen busy={!isError} title={isError ? m.login_link_invalid_title() : undefined}>
      {isError && (
        <>
          <h1>{m.login_link_invalid_title()}</h1>
          <p className="auth__lead">{m.login_link_invalid_body()}</p>
        </>
      )}
    </AuthScreen>
  );
}
